import { UseQueryResult } from '@tanstack/react-query'
import useApi, { type ResponseError } from '@/api/base/useApi'
import { Company } from '@/types'

export type FetchCompanyVars = {
  companyId?: number
}

async function fetchCompanies(accessToken?: string, userId?: string, variables?: FetchCompanyVars): Promise<Company> {
  if (!accessToken) {
    return Promise.reject('No access token (fetchCompanies).')
  }

  if (!variables || !variables?.companyId) {
    return Promise.reject('Missing companyId.')
  }

  const companyId = String(variables.companyId)
  const url = `${process.env['NEXT_PUBLIC_API_ENDPOINT']}companies/${companyId}`
  const requestHeaders: any = { Authorization: 'Bearer ' + accessToken, 'auth0-user-id': userId }
  const response = await fetch(url, {
    method: 'GET',
    headers: requestHeaders,
  })

  if (response.status !== 200) {
    const json: ResponseError = await response.json()
    console.log('[fetchCompanies] Error', response.status, json)
    return Promise.reject(json)
  }

  return response.json()
}

const useCompanyQueryV1 = (companyId: number | undefined, enabled?: boolean): UseQueryResult<Company, any> => {
  return useApi(
    ['company', `company_${companyId}`],
    fetchCompanies,
    { companyId: companyId },
    companyId !== undefined || enabled !== false,
  )
}

export default useCompanyQueryV1
